import { FacebookLogo, InstagramLogo, EnvelopeSimple } from "@phosphor-icons/react";
import Logo from "./Logo";

const year = new Date().getFullYear();

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#0A0A0A] text-white">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-16 md:py-20">
        <div className="grid grid-cols-2 md:grid-cols-12 gap-10">
          <div className="col-span-2 md:col-span-5">
            <div className="mb-6">
              <Logo size="lg" withText={false} />
            </div>
            <p className="text-zinc-400 max-w-sm leading-relaxed">
              Built in Strabane. Used daily across the wider area. Local food,
              coffee and groceries from the shops that make the place feel
              like home.
            </p>
            <div className="mt-8 flex items-center gap-3">
              {[
                { Icon: FacebookLogo, href: "https://www.facebook.com/mylocalordering", label: "facebook" },
                { Icon: InstagramLogo, href: "https://www.instagram.com/mylocal_app/", label: "instagram" },
              ].map(({ Icon, href, label }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noreferrer"
                  data-testid={`social-${label}`}
                  aria-label={label}
                  className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-white/[0.06] border border-white/10 hover:bg-white/[0.1] transition-colors"
                >
                  <Icon size={18} weight="duotone" />
                </a>
              ))}
            </div>
          </div>

          <div className="md:col-span-2">
            <p className="overline text-zinc-500 mb-4">Platform</p>
            <ul className="space-y-3 text-sm">
              <li><a href="#how" className="text-zinc-300 hover:text-white">How it works</a></li>
              <li><a href="#businesses" className="text-zinc-300 hover:text-white">Businesses</a></li>
              <li><a href="#download" className="text-zinc-300 hover:text-white">Download</a></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <p className="overline text-zinc-500 mb-4">Business</p>
            <ul className="space-y-3 text-sm">
              <li><a href="/partner" data-testid="footer-partner-link" className="text-zinc-300 hover:text-white">Become a partner</a></li>
              <li><a href="https://www.mylocalordering.co.uk" target="_blank" rel="noreferrer" className="text-zinc-300 hover:text-white">For merchants</a></li>
              <li><a href="/#why" className="text-zinc-300 hover:text-white">Our ethos</a></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="overline text-zinc-500 mb-4">Contact</p>
            <a
              href="mailto:hello@mylocalapp.shop"
              data-testid="footer-email"
              className="inline-flex items-center gap-2 text-sm text-zinc-300 hover:text-white"
            >
              <EnvelopeSimple size={16} weight="duotone" />
              hello@mylocalapp.shop
            </a>
            <p className="mt-4 text-sm text-zinc-500 leading-relaxed">
              Strabane and the wider area,<br />
              Northern Ireland
            </p>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row gap-4 md:items-center md:justify-between text-xs text-zinc-500">
          <p>© {year} My Local App. Used daily across Strabane and the wider area.</p>
          <div className="flex items-center gap-6">
            <a href="#" className="hover:text-white">Privacy</a>
            <a href="#" className="hover:text-white">Terms</a>
            <a href="#" className="hover:text-white">Cookies</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
